/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { nodesGetApiV3NodesNodeId } from "../../funcs/nodesGetApiV3NodesNodeId.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3NodesNodeIdRequest$inboundSchema,
};

export const tool$nodesGetApiV3NodesNodeId: ToolDefinition<typeof args> = {
  name: "nodes-get-api-v3-nodes-node-id",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await nodesGetApiV3NodesNodeId(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
